import api_base from "@/api/base";
import { Permission } from "@/views/roles/data/schema";

export const get_permissions = async (): Promise<Permission[]> => {
  const response = await api_base.get("/api/v1/permissions/");
  return response.data;
};
